import { useCallback } from 'react';

import clsx from 'clsx';
import { match } from 'ts-pattern';

import { Image } from '@components/Image';

interface TestimonialsCloudAvatarsProps {
  data: Testimonial[];
  selected: number;
  onClick: (index: number) => void | undefined;
}

export const TestimonialsCloudAvatars: React.FC<
  TestimonialsCloudAvatarsProps
> = ({ data, selected, onClick }) => {
  const handler = useCallback(
    (event: HTMLElementEvent<HTMLButtonElement>) => {
      const element = event.target.closest('[data-index]');
      const index = Number(element?.getAttribute('data-index'));

      if (isNaN(index) || index === selected) {
        return;
      }

      onClick(Number(index));
    },
    [onClick, selected],
  );

  return (
    <div className="flex items-center justify-center gap-5">
      {data?.map((_, index) => {
        const className = match(index)
          .with(selected, () => 'mt-0 h-16 w-16 opacity-100')
          .with(
            selected - 1,
            selected + 1,
            () => 'mt-8 h-8 w-8 md:mt-4 md:h-12 md:w-12 opacity-60',
          )
          .otherwise(() => 'mt-8 h-8 w-8 md:mt-4 opacity-30');

        return (
          <button
            key={index}
            onClick={handler}
            data-index={index}
            className={clsx(
              'transform cursor-pointer select-none transition-all duration-700 ease-out',
              className,
            )}
          >
            <Image
              src={data[index]?.image}
              className="rounded-full border border-white object-cover hover:shadow-lg"
              title={data[index]?.author_name}
            />
          </button>
        );
      })}
    </div>
  );
};
